import React from 'react'
import { FaInstagram, FaTelegramPlane } from 'react-icons/fa'
import { BsTelephone } from 'react-icons/bs'
import { Link } from 'react-router-dom';

export default function Footer({ data }) {
  return (
    <footer className="relative pt-14 pb-8">
      {/* soft background */}

      <div className="container mx-auto px-6">

        {/* TOP */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">

          {/* brand */}
          <section>
            {data?.logo && (
              <img
                loading="lazy"
                src={`data:image/jpeg;base64,${data.logo}`}
                alt="logo"
                className="h-[42px]"
              />
            )}
            <p className="mt-4 text-sm text-slate-600 leading-7 max-w-[280px]">
              مرکز تصویربرداری عارف — ارائه خدمات CT، MRI، سونوگرافی و رادیولوژی با تجهیزات به‌روز.
            </p>
          </section>

          {/* links */}
          <section>
            <p className="text-sm font-extrabold text-slate-900">دسترسی سریع</p>
            <div className="mt-4 space-y-2 text-sm text-slate-600">
              <Link to="/reservation" className="block hover:text-slate-900 transition">
                نوبت‌دهی آنلاین
              </Link>
              <a href="https://report.aref-medical.com/patient?q=YXJlZi1yZXBvcnQ"
                 target="_blank" rel="noreferrer"
                 className="block hover:text-slate-900 transition">
                جواب‌دهی بیماران
              </a>
              <a href="https://report.aref-medical.com/doctor?q=YXJlZi1yZXBvcnQ"
                 target="_blank" rel="noreferrer"
                 className="block hover:text-slate-900 transition">
                ورود پزشکان
              </a>
            </div>
          </section>

          {/* contact */}
          <section>
            <p className="text-sm font-extrabold text-slate-900">ارتباط</p>

            <div className="mt-4 space-y-3 text-sm text-slate-600">

              <a href="tel:05138419041"
                 className="flex items-center gap-2 hover:text-slate-900 transition">
                <BsTelephone className="text-slate-700 -scale-x-100" />
                051-38419041
              </a>

              <a href="https://instagram.com/"
                 target="_blank" rel="noopener noreferrer"
                 className="flex items-center gap-2 hover:text-slate-900 transition">
                <FaInstagram className="text-slate-700" />
                اینستاگرام
              </a>

              <a href="https://t.me/"
                 target="_blank" rel="noopener noreferrer"
                 className="flex items-center gap-2 hover:text-slate-900 transition">
                <FaTelegramPlane className="text-slate-700" />
                تلگرام
              </a>

            </div>
          </section>

        </div>

        {/* DIVIDER */}
        <div className="mt-10 h-[1px] w-full bg-gradient-to-r from-transparent via-slate-200 to-transparent" />

        {/* BOTTOM */}
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs sm:text-sm text-slate-500">
          <p>© {new Date().getFullYear()} مرکز تصویربرداری عارف</p>

          <div className="flex items-center gap-3">
            <span className="opacity-70">ساخته شده با</span>
            <span className="text-[#06b6d4] font-bold">♥</span>
          </div>
        </div>

      </div>
    </footer>
  )
}
